import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Tooltip } from 'components/core/Tooltip';
import { IconBanner } from 'components/core/IconBanner';
import InfoIcon from 'components/svg/InfoIcon';

import './TooltipBanner.scss';

export function TooltipBanner({
	tooltipContent,
	bannerIcon,
	theme,
	textColor,
	bannerText,
	tooltipIcon = <InfoIcon />,
	last,
	className,
}) {
	return (
		<Tooltip
			className={classnames('tooltip-banner', className, { last })}
			content={<div>{tooltipContent}</div>}
		>
			<div className="tooltip-icon"> {tooltipIcon} </div>
			{bannerIcon && (
				<IconBanner
					className="icon-banner"
					icon={bannerIcon}
					theme={theme}
					textColor={textColor}
					bannerText={bannerText}
				/>
			)}
		</Tooltip>
	);
}

TooltipBanner.propTypes = {
	tooltipContent: PropTypes.string,
	theme: PropTypes.oneOf(['orange', 'green']),
	bannerIcon: PropTypes.element,
	textColor: PropTypes.string,
	bannerText: PropTypes.string,
	tooltipIcon: PropTypes.element,
	last: PropTypes.bool,
	className: PropTypes.string,
};

export default TooltipBanner;
